/**
 * Market type alias mappings (racing etc.).
 * Replaces caribe7/lib/constants/markets/alias-type-mappings.js.
 */

/** Dogs market type alias (sport id: 10) */
export const DOGS_MARKET_TYPE_ALIAS: Record<string, number> = {
  winner: 1001,
  place: 1002,
  show: 1003,
  'straight-forecast': 1004,
  'combination-forecast': 1005,
  'straight-tricast': 1006,
  'combination-tricast': 1007,
};

/** Horses market type alias (sport id: 20) */
export const HORSES_MARKET_TYPE_ALIAS: Record<string, number> = {
  winner: 2001,
  place: 2002,
  show: 2003,
  'straight-forecast': 2004,
  'combination-forecast': 2005,
  'straight-tricast': 2006,
  'combination-tricast': 2007,
};

/** Baseball market type alias (sport id: 40) */
export const BASEBALL_MARKET_TYPE_ALIAS: Record<string, number> = {
  'final-outcome': 4001,
  'number-of-pitches': 4002,
  'final-outcome-number-of-pitches': 4003,
  'final-outcome-under-over': 4004,
};
